import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { View } from 'react-native';

import ListView from '../list-view';
import Arrow from '../arrow';

import styles, { arrowSVGStyles } from './accordion.styles';

const COLLAPSIBLE_PROPS = ["align", "collapsed", "collapsedHeight", "duration", "easing"];
const VIEW_PROPS = ["align", "collapsed", "collapsedHeight", "duration", "easing"];

class Accordion extends Component {
  static propTypes = {

    markerStyle: PropTypes.shape({
      fill: PropTypes.string,
    }),
    sections: PropTypes.array.isRequired,
    renderHeader: PropTypes.func.isRequired,
    renderContent: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    align: PropTypes.oneOf(['top', 'center', 'bottom']),
    duration: PropTypes.number,
    easing: PropTypes.string,
    initiallyActiveSection: PropTypes.number,
    activeSection: PropTypes.oneOfType([
      PropTypes.bool, // if false, closes all sections
      PropTypes.number, // sets index of section to open
    ]),
    underlayColor: PropTypes.string,
    customArrowCSS: PropTypes.bool,
  };

  static defaultProps = {
    underlayColor: 'black',
    customArrowCSS: false,
  };

  constructor(props) {
    super(props);
    // if activeSection not specified, default to initiallyActiveSection
    this.state = {
      activeSection: props.activeSection !== undefined ? props.activeSection : props.initiallyActiveSection,
    };
  }

  _toggleSection(section) {
    const activeSection = this.state.activeSection === section ? false : section;
    if (this.props.activeSection === undefined) {
      this.setState({ activeSection });
    }
    if (this.props.onChange) {
      this.props.onChange(activeSection);
    }
  }


  displayArrow(display) {
    if (display == false) {
      return (
        <Arrow
          direction="down"
          {...arrowSVGStyles}
        />
      );
    }


    if (display == true) {
      return (
        <View style={styles.rotate180}>
          <Arrow
            direction="down"
            {...arrowSVGStyles}
          />
        </View>
      );
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeSection !== undefined) {
      this.setState({
        activeSection: nextProps.activeSection,
      });
    }
  }

  render() {
    let viewProps = {};
    let collapsibleProps = {};
    const { customArrowCSS } = this.props;
    const customArrowValue = classNames('arrow-pointer', { 'custom-arrow-pointer': customArrowCSS });

    Object.keys(this.props).forEach((key) => {
      if (COLLAPSIBLE_PROPS.indexOf(key) !== -1) {
        collapsibleProps[key] = this.props[key];
      } else if (VIEW_PROPS.indexOf(key) !== -1) {
        viewProps[key] = this.props[key];
      }
    });

    return (
      <div className="accordion-list" {...viewProps}>
        {this.props.sections.map((section, key) => (
          <div className="border-bottom" key={key}>
            <ListView.Row markerStyle={this.props.markerStyle}>
              <div onClick={() => this._toggleSection(key)} className="list-item">
                <div className={customArrowValue}>
                  {this.displayArrow(this.state.activeSection === key)}
                </div>
                <div className="row">
                  <div className="columns small-12">
                    <div>
                      <div className="row">
                        <div className="column small-12 text-left">
                          {this.props.renderHeader(section, key, this.state.activeSection === key)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.activeSection === key &&
                <div onClick={() => this._toggleSection(key)} className="row" className={'commonWidth'}>
                  <div className="small-12 column">
                    {this.props.renderContent(section, key, this.state.activeSection === key)}
                  </div>
                </div>
              }
            </ListView.Row>
          </div>
        ))}
      </div>
    );
  }
}

export default Accordion;
